
import { computed, defineComponent, onMounted, onUnmounted, reactive } from 'vue'
import ChainTag from './ChainTag.vue'
import GreetingCard from './GreetingCard.vue'

export default defineComponent({
  components: { GreetingCard, ChainTag },

  props: {
    chainId: {
      type: Number,
      required: true
    },
    from: {
      type: String,
      required: true
    },
    tokenName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },

  setup (props) {
    const timing = reactive({
      minu: 0,
      second: 0
    })

    const titleFilter = computed(() => props.title.substring(1))

    // eslint-disable-next-line no-undef
    let timer: NodeJS.Timer

    function timingHandler () {
      timing.second++

      if (timing.second === 60) {
        timing.second = 0
        timing.minu++
      }
    }

    onMounted(() => {
      timer = setInterval(() => timingHandler(), 1000)
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    return {
      timing,
      titleFilter
    }
  }
})
